import { httpsCallable } from "firebase/functions";

import { cloudFunctions } from "./getFunctions";
import {
  CloudFunctionResponse,
  CallablesGeneral,
  LoginMagicLinkEnviarMail
} from "@fixeduy/restaurantestypes";

const loginMagicLinkEnviarMail = async (
  data: LoginMagicLinkEnviarMail
): Promise<CloudFunctionResponse> => {
  const run = httpsCallable<CallablesGeneral, CloudFunctionResponse>(
    cloudFunctions,
    "callablesGenerales"
  );
  const result = await run({
    func: "loginMagicLinkEnviarMail",
    params: data
  });
  return result.data;
};

export { loginMagicLinkEnviarMail };
